const treatmentsData = [
  {
    category: "headSpa",
    title: "Women Deluxe",
    description: "treatments.treatmentCards.womenDeluxe.description",
    duration: "60 min",
    price: "€75,-",
    steps: [
      "analysis",
      "massage",
      "cleanse",
      "masker",
      "conditioning",
      "oil",
      "drying",
    ].map((step) => ({
      header: `treatments.treatmentCards.womenDeluxe.steps.${step}.header`,
      detail: `treatments.treatmentCards.womenDeluxe.steps.${step}.detail`,
    })),
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000031054"
  },
  {
    category: "headSpa",
    title: "Women Ultra Deluxe",
    description: "treatments.treatmentCards.womenUltraDeluxe.description",
    duration: "90 min",
    price: "€95,-",
    steps: [
      "analysis",
      "massage",
      "cleanse",
      "masker",
      "neckmassage",
      "conditioning",
      "oil",
      "guasha",
      "drying",
    ].map((step) => ({
      header: `treatments.treatmentCards.womenUltraDeluxe.steps.${step}.header`,
      detail: `treatments.treatmentCards.womenUltraDeluxe.steps.${step}.detail`,
    })),
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000087102"
  },
  {
    category: "headSpa",
    title: "Men Deluxe",
    description: "treatments.treatmentCards.menDeluxe.description",
    duration: "60 min",
    price: "€75,-",
    steps: [
      "analysis",
      "massage",
      "cleanse",
      "masker",
      "conditioning",
      "oil",
      "drying",
    ].map((step) => ({
      header: `treatments.treatmentCards.menDeluxe.steps.${step}.header`,
      detail: `treatments.treatmentCards.menDeluxe.steps.${step}.detail`,
    })),
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000087134"
  },
  {
    category: "headSpa",
    title: "Men Ultra Deluxe",
    description: "treatments.treatmentCards.menUltraDeluxe.description",
    duration: "90 min",
    price: "€95,-",
    steps: [
      "analysis",
      "massage",
      "cleanse",
      "masker",
      "neckmassage",
      "conditioning",
      "oil",
      "guasha",
      "beard",
      "drying",
    ].map((step) => ({
      header: `treatments.treatmentCards.menUltraDeluxe.steps.${step}.header`,
      detail: `treatments.treatmentCards.menUltraDeluxe.steps.${step}.detail`,
    })),
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000147384"
  },
  {
    category: "headSpa",
    title: "Kids Deluxe",
    description: "treatments.treatmentCards.kidsDeluxe.description",
    duration: "30 min",
    price: "€40,-",
    rules: "treatments.treatmentCards.kidsDeluxe.rules",
    rules2: "treatments.treatmentCards.kidsDeluxe.rules2",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000087166"
  },
  {
    category: "headSpa",
    title: "Hair Play",
    description: "treatments.treatmentCards.hairPlay.description",
    subdescription: "treatments.treatmentCards.hairPlay.subdescription",
    duration: "30 min",
    price: "€45,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000267908"
  },
  {
    category: "headSpa",
    title: "Hair Play Deluxe",
    description: "treatments.treatmentCards.hairPlayDeluxe.description",
    subdescription: "treatments.treatmentCards.hairPlayDeluxe.subdescription",
    duration: "60 min",
    price: "€65,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000267944"
  },
  {
    category: "massages",
    title: "Back Massage",
    description: "treatments.treatmentCards.backMassage.description",
    subdescription: "treatments.treatmentCards.backMassage.subdescription",
    duration: "30 min",
    price: "€45,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000267304"
  },
  {
    category: "massages",
    title: "Back Massage Deluxe",
    description: "treatments.treatmentCards.backMassageDeluxe.description",
    subdescription: "treatments.treatmentCards.backMassageDeluxe.subdescription",
    duration: "60 min",
    price: "€65,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616014"
  },
  {
    category: "massages",
    title: "Foot Massage",
    description: "treatments.treatmentCards.footMassage.description",
    subdescription: "treatments.treatmentCards.footMassage.subdescription",
    duration: "30 min",
    price: "€40,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616056"
  },
  {
    category: "massages",
    title: "Foot Massage Deluxe",
    description: "treatments.treatmentCards.footMassageDeluxe.description",
    subdescription: "treatments.treatmentCards.footMassageDeluxe.subdescription",
    duration: "60 min",
    price: "€65,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616098"
  },
  {
    category: "massages",
    title: "Women Body Massage",
    description: "treatments.treatmentCards.womenBodyMassage.description",
    subdescription: "treatments.treatmentCards.womenBodyMassage.subdescription",
    duration: "60 min",
    price: "€75,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616140"
  },
  {
    category: "mesotherapy",
    title: "Hair Mesotherapy",
    description: "treatments.treatmentCards.hairMesotherapy.description",
    rules: "treatments.treatmentCards.hairMesotherapy.rules",
    subdescription: "treatments.treatmentCards.hairMesotherapy.subdescription",
    rules2: "treatments.treatmentCards.hairMesotherapy.rules2",
    duration: "60 min",
    price: "€170,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000000267980"
  },
  {
    category: "mesotherapy",
    title: "Meso Combideal 6+1",
    description: "treatments.treatmentCards.mesotherapyCombideal.description",
    rules: "treatments.treatmentCards.mesotherapyCombideal.rules",
    subdescription: "treatments.treatmentCards.mesotherapyCombideal.subdescription",
    rules2: "treatments.treatmentCards.mesotherapyCombideal.rules2",
    duration: "60 min",
    price: "€1020,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001614008"
  },
  {
    category: "combiDeals",
    title: "Deluxe & Back Massage",
    description: "treatments.treatmentCards.deluxeBackMassage.description",
    subdescription: "treatments.treatmentCards.deluxeBackMassage.subdescription",
    duration: "75 min",
    price: "€95,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616202"
  },
  {
    category: "combiDeals",
    title: "Ultra Deluxe & Back Massage",
    description: "treatments.treatmentCards.ultraDeluxeBackMassage.description",
    subdescription: "treatments.treatmentCards.ultraDeluxeBackMassage.subdescription",
    duration: "105 min",
    price: "€115,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616256"
  },
  {
    category: "combiDeals",
    title: "Deluxe & Back and Foot Massage",
    description: "treatments.treatmentCards.deluxeBackFootMassage.description",
    subdescription: "treatments.treatmentCards.deluxeBackFootMassage.subdescription",
    duration: "90 min",
    price: "€115,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616306"
  },
  {
    category: "combiDeals",
    title: "Hair Play & Foot Massage",
    description: "treatments.treatmentCards.hairPlayFootMassage.description",
    subdescription: "treatments.treatmentCards.hairPlayFootMassage.subdescription",
    duration: "60 min",
    price: "€80,-",
    link: "https://headwellness.zohobookings.eu/portal-embed#/186536000001616354"
  },
// Add more treatments as needed
];

export default treatmentsData;
